<template>
  <div class="projects container-fluid">
    <div class="col-10 text">
      <h2>
        TO WYJĄTKOWA KOLEKCJA PODŁÓG CHARAKTERYZUJĄCA SIĘ NIEREGULARNĄ FAKTURĄ,
        PODKREŚLONYM, WYRAŹNYM RYSUNKIEM SŁOJÓW, WGNIECENIAMI POWIERZCHNI
        PRZYCZYNIAJĄCYMI SIĘ DO EFEKTU „DESEK NADGRYZIONYCH PRZEZ CZAS”. RĘCZNE
        WYKONANIA SPRAWIA, ŻE PODŁOGI Z TEJ KOLEKCJI SĄ NAPRAWDĘ NIEPOWTARZALNE.
      </h2>
      <p>
        Prezentowane Państwu na tej stronie podłogi postarzane to kolekcja
        charakteryzująca się nieregularną fakturą, podkreślonym, wyraźnym
        rysunkiem słojów i wgnieceniami powierzchni, przyczyniającymi się do
        efektu postarzanych „desek z innej epoki”. Ręczna obróbka, koloryzowanie
        i zabezpieczenie powierzchni specjalnym woskiem sprawiają, że każda
        nasza propozycja jest wyjątkowa. Produkty z Kolekcji Antycznej
        wytwarzamy ze szczególną starannością i uwag. W dużej mierze nasze
        produkty wykańczamy ręcznie pod indywidualne zamówienie Klienta, co daje
        gwarancję 100% niepowtarzalności.
      </p>
      <h2>DESKA POSTARZANA RĘCZNIE</h2>
      <p>
        Kolekcja Antyczna to deski naprawdę wyjątkowe. Każda deska robiona jest
        ręcznie, od procesu postarzania powierzchni aż po malowanie. Nigdy nie
        trafią się dwa takie same wzory i identyczne deski, jak w przypadku
        maszyn, które zawsze mają swoją powtarzalność. Wzory dostępne u nas są
        ciężką pracą wielu fachowców, artystów, projektantów oraz naszych,
        którzy spośród setek wybrali najpiękniejsze. Jednak prosimy nie
        ograniczać swojej wyobraźni, wykonujemy również zamówienia specjalne!
      </p>
    </div>
    <div
      v-scrollanimation
      class="image col-10 col-sm-5 col-md-4 col-xl-3"
      v-for="(image, index) in media"
      :key="index"
      @click="openGallery(index)"
      :style="{
        width: 'auto',
        height: '17rem'
      }"
    >
      <img v-lazy="image.src || image.thumb" @click="openGallery(index)" />
      <h3>{{ image.caption }}</h3>
    </div>

    <LightBox
      ref="lightbox"
      :media="media"
      :show-caption="true"
      :show-light-box="false"
    />
  </div>
</template>

<script>
require("vue-image-lightbox/dist/vue-image-lightbox.min.css");
import Images from "./champions.js";
import LightBox from "vue-image-lightbox";
export default {
  data: function() {
    return {
      index: null,
      media: Images
    };
  },
  methods: {
    openGallery(index) {
      this.$refs.lightbox.showImage(index);
    }
  },

  components: {
    LightBox
  }
};
</script>
<style scoped>
.text {
  text-align: center;
  margin-top: 2%;
}
.projects {
  background-color: rgb(255, 255, 255);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}

.image {
  height: auto;
  display: inline-block;
  position: relative;
  transition: 0.3s;
  margin: 1%;
}

.image img {
  width: 100%;
  height: 100%;
  transition: 0.3s;
  border-radius: 4px;
}

.image:hover img {
  filter: blur(2px) brightness(60%);
  box-shadow: 0 0 16px rgb(32, 28, 28);
  cursor: pointer;
}

.image :not(img) {
  position: absolute;
  z-index: 1;
  width: 90%;
  top: 50%;

  left: 5%;
  color: #fff;
  opacity: 0;
  transition: 0.3s;
}

.image:hover :not(img) {
  cursor: pointer;
  opacity: 1;
}
</style>
